<template>
  <div>
    <div class="main">
      <div class="nav">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/deepPro2' }">深基坑监测</el-breadcrumb-item>
          <el-breadcrumb-item>添加传感器</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="btns">
          <div class="btn btn1" @click="enterDataList">历史设置</div>
          <div class="btn" @click="dataSet">预警设置</div>
        </div>
      </div>
      <div class="table-box">
        <el-table
        height="73vh"
        :data="list"
        
        style="width: 100%"
       >
        <!-- <el-table-column
          type="selection"
          width="55"> -->
        </el-table-column>
        <el-table-column
        type="index"
          label="序号"
          width="120">
        </el-table-column>
        <el-table-column
          prop="name"
          label="名称"
          width="120">
        </el-table-column>
        <el-table-column
          prop="tsSersorImei"
          label="设备号"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="online"
          label="设备状态"
          >
          <template slot-scope="scope">
            <i :class="scope.row.online==='在线'?'el-icon-success luse':'el-icon-error red'"></i>
            <span :class="scope.row.online==='在线'?'luse':'red'" style="margin-left: 10px">{{ scope.row.online }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="deepSersorTypeName"
          label="设备类型"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="nowValue"
          label="实际值/mm"
          >
        </el-table-column>
        <el-table-column
          prop="warning"
          label="预警值/mm"
          >
        </el-table-column>
        <el-table-column
          prop="updateDate"
          label="监测日期"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column         
          label="操作">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="success"
              plain
              @click="handleClick(scope.row)">编辑</el-button>
            <el-button
              size="mini"
              type="danger"
              plain
              @click="delItem(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      </div>
      <el-dialog
      top="30vh"
        title="编辑"
        :visible.sync="dialogVisible1"
        width="35%"
        >
        <div>
           <div class="row" style="padding-left:32px;margin-bottom:20px">
            传感器名称：<div style="width:70%"><el-input v-model="row1.name"></el-input></div>
          </div>
          <div class="row" style="padding-left:32px;margin-bottom:20px">
            传感器编号：<div style="width:70%"><el-input v-model="row1.tsSersorImei"></el-input></div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible1 = false">取 消</el-button>
          <el-button type="primary" @click="updata">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog
      top="30vh"
        title="预警值设置"
        :visible.sync="dialogVisible"
        width="35%"
        >
        <div>
           <div class="row" style="padding-left:32px;margin-bottom:20px">
            传感器预警值：<div style="width:70%"><el-input v-model="valueSet"></el-input></div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="senserWaringValueSet">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import myHttp from '../../untils/port'
import util from '../../untils/util'
  export default {
     data() {
      return {
        options: [{
          value: '0',
          label: '压力'
        }, {
          value: '1',
          label: '位移'
        }, {
          value: '2',
          label: '倾角'
        }],
        value: '',
        form:{
          name:''
        },
        dialogVisible:false,
        dialogVisible1:false,
        tableData: [],
        list:[],
        row:[],
        row1:[],
        valueSet:'',
        title:'kg',
        
      }
    },
    mounted(){
      this.queryTsDtuSensorList()
    },
    methods:{
      enterDataList(){
        this.$router.push({
          path:'/deepProItemList',
          query:{
            projectId:util.session.get('groupId'),
            tsSersorType:this.$route.query.tsSenserType,
            tsDtuId:this.$route.query.tsDtuId
          }
        })
      },
      queryTsDtuSensorList(){
        myHttp.queryTsDtuSensorList({
          tsDtuId:`${this.$route.query.tsDtuId}`,
          tsSenserType:`${this.$route.query.tsSenserType}`
        }).then(res=>{
          if(res.data.code==200){
            console.log(res)
            if(res.data.data.List.length!=0){
              this.list = res.data.data.List
              console.log(this.list)
            }else{
              this.$router.go(-1)
              this.$message({
                message:'暂无数据',
                type:'warning'
              })
            }
          }
        })
      },
      dataSet(){
        this.dialogVisible = true
      },
      senserWaringValueSet(){
        myHttp.senserWaringValueSet({
          tsDtuId:`${this.$route.query.tsDtuId}`,
          tsSenserType:`${this.$route.query.tsSenserType}`,
          warningValue:`${this.valueSet}`
        }).then(res=>{
          if(res.data.code==200){
            this.$message({
              message:`${res.data.msg}`,
              type:'success'
            })
            this.dialogVisible = false
            this.queryTsDtuSensorList()
          }else{
            this.$message({
              message:`${res.data.msg}`,
              type:'warning'
            })
          }
        })
      },
      delItem(index){
        let that = this
        this.$confirm('此操作将删除该传感器, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          myHttp.deleteTsDtuSensorDTU({
            id:index.id,
            updateBy:`${util.session.get('groupId')}`
          }).then(res=>{
              that.$message({
              type: 'success',
              message: `${res.data.msg}`
            })
            that.queryTsDtuSensorList()
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
      },
      handleClick(index){
        this.dialogVisible1 = true
        this.row = index
        console.log(this.row)
        this.row1={ ...index }
      },
      updata(){
        let that = this
        myHttp.uptTsDtuSensor({
          tsSersorType:`${this.$route.query.tsSenserType}`,
          updateBy:`${util.session.get('groupId')}`,
          tsSersorImei:this.row1.name,
          name:this.row1.tsSersorImei,
          id:this.row1.id,
          tsDtuId:`${this.$route.query.tsDtuId}`
        }).then(res=>{
          if(res.data.code==200){
            this.queryTsDtuSensorList()
            this.dialogVisible1 = false
            that.$message({
              type: 'success',
              message: `${res.data.msg}`
            })
          }else{
            that.$message({
              message:`${res.data.msg}`,
              type:'warning'
            })
          }
        })
      },
      // 添加传感器
      addList(){
        this.dialogVisible= true
      },
      additem(){
        this.dialogVisible1= true
      }
    }
  }
</script>

<style scoped>
.main{
  height: 90.6vh;
  padding: 0 0.5%;
  background-color: #fff;
}
.nav{
  height: 60px;
  display: flex;justify-content: space-between;
  align-items:center;
}
.dian{
  position: relative;
}
.dian::after{
  position: absolute;
  content: "";
  left: 30%;
  top: 27%;
  width: 8px;
  height: 8px;
  background: #75CA82;
  border: 1px solid #75CA82;
  border-radius: 50%;
}
.table-box{
  height: 73vh;
  box-shadow: 0px 3px 10px 0px 
		rgba(105, 159, 204, 0.5);
	border-radius: 6px;
  overflow: hidden;
  margin-bottom: 1%;
}
.btn{
  width: 100px;
height: 40px;
background: #F56C6C;
border-radius: 4px;
font-size: 16px;
font-family: Microsoft YaHei;
font-weight: bold;
color: #FFFFFF;
line-height: 40px;
text-align: center;
}
.btn1{
background: #E6A23C;
margin-right: 15px;
}
.btn:hover{
  opacity: 0.7;
  cursor: pointer;
}
.el-breadcrumb{
  font-size: 19px;
}
.btns{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.luse{
color: rgb(44, 231, 44);
}
.red{
  color: rgb(230, 65, 36);
}
.row{
  display: flex;
}
</style>